import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { mergeMap } from 'rxjs/operators';

import { DevicesService } from '@era/locations-sdk';
import {
  DeviceAssignmentHistoryResolverActions,
  DeviceAssignmentHistoryApiActions,
} from './device-assignment-history.actions';
import { safeMap } from '@era/stores';

@Injectable()
export class DeviceAssignmentHistoryEffects {
  constructor(
    private deviceService: DevicesService,
    private readonly actions$: Actions
  ) {}

  deviceAssignmentHistoryRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceAssignmentHistoryResolverActions.historyRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.deviceService.getDeviceAssignmentHistory(udid),
          (history) => DeviceAssignmentHistoryApiActions.historyLoaded({ history, udid }),
          (error) => DeviceAssignmentHistoryApiActions.historyLoadedError({ error })
        )
      )
    );
  });
}
